// ── Status constants ──────────────────────────────────────────────
export const PayrollStatus = {
    TO_BE_PAID: 1,
    PENDING: 2,
    PAID: 3,
    REJECTED: 4,
} as const;

export type PayrollStatusId = (typeof PayrollStatus)[keyof typeof PayrollStatus];

// ── API response DTOs ─────────────────────────────────────────────

/** Row returned by GET companies-with-payroll-invoice */
export interface PayrollCompany {
    companyId: number;
    companyName: string;
}

/** Row returned by GET payroll-payment-invoice/companyId/{id} */
export interface PayrollPaymentSummary {
    payDayPayRollHdrId: number;
    payDayPayRollDtlId: number;
    payRollInvoiceNumber: string;
    companyId: number;
    statusId: PayrollStatusId;
    statusDescription: string;
    invoiceAmount: number;
    isApproved: boolean;
    isAuthorized: boolean | null;
    versionNumber: number;
    createdDate: string;
    authorizedDate: string | null;
    authorizedBy: string;
}

/** Row returned by GET payroll-payment-invoice/company/{cId}/hdrId/{hId}/statusId/{sId} */
export interface PayrollPaymentDetail extends PayrollPaymentSummary {
    paySlipBlobUrl?: string;
}

// ── Request DTOs (sent to the API) ────────────────────────────────

export interface ApprovePayrollPaymentRequest {
    companyId: number;
    payDayPayRollHdrId: number;
    approvedBy: number;
}

export interface RejectPayrollPaymentRequest {
    companyId: number;
    payDayPayRollHdrId: number;
    rejectedBy: number;
    // NOTE: no rejectionReason — intentional difference from CIXOR Payments
}